/**
 * Import Dependency
 */
import * as types from '../mutations_types'

/**
 * Import API
 */
import authAPI from '../../services/api/auth'

/**
 * Declare Variable
 */
const state = {
	isAuthorized: JSON.parse(localStorage.getItem('isAuthorized')) || false,
	accessToken: localStorage.getItem('accessToken') || '',
	refreshToken: localStorage.getItem('refreshToken') || '',
}
const getters = {
	getAccessToken: state => state.accessToken,
	getRefreshToken: state => state.refreshToken,
	getIsAuthorized: state => state.isAuthorized
}
const actions = {
	async signin({ commit, dispatch }, context) {
		return authAPI.signin(context).then((response) => {
			commit(types.LOGIN_SUCCESS, response.data)
			dispatch('pnotify/alert', {
				text: `Welcome, ${response.data.user.name}.`,
				addclass: 'bg-primary border-primary'
			}, {root:true});
			dispatch('user/SET_USER', response.data.user, {root:true})
			return Promise.resolve(response.data)

		}).catch((error) => {
			console.group('[Vuex][Actions] Error from signin')
			console.log(error)
			console.groupEnd()

			dispatch('pnotify/alert', {
				text: error.response.data.message,
				addclass: 'bg-danger border-danger'
			}, {root:true});
			commit(types.LOGIN_FAILED, {})
			dispatch('user/SET_USER', null, {root:true})
			return Promise.reject(error.response.data)
		})
	},

	async refreshToken({ commit, dispatch }, context) {
		return authAPI.refreshToken(context).then((response) => {
			commit(types.LOGIN_SUCCESS, response.data)
			if (response.data.user) {
				dispatch('user/SET_USER', response.data.user, {root: true})
			}
			return Promise.resolve(response.data)
		}).catch((error) => {
			commit(types.LOGIN_FAILED, {})
			dispatch('user/SET_USER', null, {root:true})
			return Promise.reject(error.response.data)
		})
	},

	async passwordreset({ commit, dispatch }, context) {
		try {
			const response = await authAPI.passwordreset(context)
			if (response.data.status){
				dispatch('pnotify/alert', {
			        text: response.data.status.message,
			        addclass: 'bg-primary border-primary'
			    }, {root:true});
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
			        text: response.data.status.message,
			        addclass: 'bg-warning border-warning'
			    }, {root:true});
				return Promise.reject(response.data)
			}
			return Promise.reject(response.data)
		} catch (e) {
			console.group('[Vuex][Actions] Error Password request')
			console.log(e)
			console.log(e.response)
			console.groupEnd()
			dispatch('pnotify/alert', {
		        text: 'There was a problem with your request',
		        addclass: 'bg-primary border-primary'
		    }, {root:true});
			return Promise.reject(e.response)
		}
	},
	async passwordchange({ commit, dispatch }, context) {
		try {
			const response = await authAPI.passwordchange(context)
			if (response.data.status){
				dispatch('pnotify/alert', {
			        text: response.data.status.message,
			        addclass: 'bg-primary border-primary'
			    }, {root:true});
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
			        text: response.data.status.message,
			        addclass: 'bg-warning border-warning'
			    }, {root:true});
				return Promise.reject(response.data)
			}
			return Promise.reject(response.data)
		} catch (e) {
			/*
			console.group('[Vuex][Actions] Error Password request')
			console.log(e)
			console.log(e.response)
			console.groupEnd()
			*/
			dispatch('pnotify/alert', {
		        text: 'There was a problem with your request',
		        addclass: 'bg-primary border-primary'
		    }, {root:true});
		}
	},

	async me({ commit, dispatch }, context) {
		try {
			const response = await authAPI.me(context)
			if (response.data.status){
				dispatch('user/SET_USER', response.data.user, {root:true})
				return Promise.resolve(response.data)
			}else{
				commit(types.LOGIN_FAILED)
				dispatch('user/SET_USER', null, {root:true})
				return Promise.reject(response.data)
			}
		} catch (e) {
			/*
			console.group('[Vuex][Actions] Error from get user authentificated')
			console.log(e)
			console.log(e.response)
			console.groupEnd()
			*/
			commit(types.LOGIN_FAILED, e.response)
			dispatch('user/SET_USER', null, {root:true})
			return Promise.reject(e.response)
		}
	},
	logout({ commit, dispatch }) {

		commit(types.LOGIN_FAILED)
		dispatch('user/SET_USER', null, {root:true})
	}
}
const mutations = {
	[types.LOGIN_SUCCESS](state, data) {
		state.accessToken = data.token;
		state.refreshToken = data.refreshToken ? data.refreshToken : '';
		state.isAuthorized = true;
		localStorage.setItem('accessToken', data.token)
		localStorage.setItem('refreshToken', data.refreshToken)
		localStorage.setItem('isAuthorized', true)
	},
	[types.LOGIN_FAILED](state, data) {
		state.accessToken = '';
		state.refreshToken = '';
		state.isAuthorized = false;
		localStorage.removeItem('accessToken');
		localStorage.removeItem('refreshToken');
		localStorage.removeItem('isAuthorized');
	}
}

/**
 * Export
 */
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}